import { Copy, Flex, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { getDeviceSpaces } from './illustrationContainerUtils';
import { IllustrationCardWrapper } from './IllustrationCardWrapper';
import { MealCreditsImage } from './MealCreditsImage';
import { GroupOrdersImage } from './GroupOrdersImage';
import { MealCreditsAction } from './MealCreditsAction';
import { GroupOrdersAction } from './GroupOrdersAction';

const BALANCE_MEAL_CREDITS_TEXT =
  'Give employees meal credits to use when ordering with Grubhub. Edit current meal credits, create new ones, and add or remove people.';
const BALANCE_GROUP_ORDERS_TEXT =
  'Save on delivery fees by placing one shared order for your team. Invite coworkers, let them add their items, then check out for everyone.';

export function BalanceIllustrationContainer(): JSX.Element {
  const { isPhone, isDesktop } = useScreenSizes();

  return (
    <Flex flexDirection={isDesktop ? 'row' : 'column'}>
      <Stack
        x={getDeviceSpaces(
          { desktopSpace: 'xx-lg', tabletSpace: 'md' },
          { isDesktop, isPhone }
        )}
        y={getDeviceSpaces(
          { phoneSpace: 'lg', tabletSpace: 'lg' },
          { isDesktop, isPhone }
        )}
        flexBasis="50%"
      >
        <IllustrationCardWrapper
          illustration={<MealCreditsImage />}
          title={<Heading variant="h3">Meal credits</Heading>}
          description={<Copy variant="body">{BALANCE_MEAL_CREDITS_TEXT}</Copy>}
          action={<MealCreditsAction />}
        />
      </Stack>
      <Flex flexBasis="50%">
        <IllustrationCardWrapper
          illustration={<GroupOrdersImage />}
          title={<Heading variant="h3">Group orders</Heading>}
          description={<Copy variant="body">{BALANCE_GROUP_ORDERS_TEXT}</Copy>}
          action={<GroupOrdersAction />}
        />
      </Flex>
    </Flex>
  );
}
